import { useCallback } from 'react'
import { useReservationNavigation } from '@/hooks/useReservationNavigation'
import { useReservationsRoute } from '@/hooks/useReservationsRoute'
import { useVenue } from '@/hooks/useVenue'

export function useOtherVenueNavigation() {
  const { primaryVenueId } = useReservationsRoute()
  const { id: venueId } = useVenue()
  const { navigateToOtherVenue } = useReservationNavigation()
  const navigate = useCallback(
    (venueUrlKey: string) => {
      if (primaryVenueId) {
        // If primary_venue_id exists, we keep the existing ID to give credit to the original venue.
        navigateToOtherVenue(venueUrlKey)
      } else {
        navigateToOtherVenue(venueUrlKey, {
          primary_venue_id: venueId,
        })
      }
    },
    [navigateToOtherVenue, primaryVenueId, venueId]
  )
  return { navigateToOtherVenue: navigate }
}
